import { BaseQuantity } from "../../interface/functionalityInterface";

export const Angle: BaseQuantity = {
  id: "001angle",
  name: "angle",
  type: "numeric",
  value: "",
  symbol: "θ",
  baseUnit: "deg",
  selectedUnit: "deg",
  units: [
    { name: "deg", fromConst: 1, toConst: 1 },
    { name: "rad", fromConst: 180 / Math.PI, toConst: Math.PI / 180 },
  ],
};
